import { initializeApp, type FirebaseApp } from 'firebase/app';
import { getAuth, connectAuthEmulator, type Auth } from 'firebase/auth';

let app: FirebaseApp | null = null;
let auth: Auth | null = null;

const apiKey = import.meta.env.VITE_FIREBASE_API_KEY;

if (apiKey && apiKey !== 'AIzaSy...n' && apiKey !== 'AIzaSy...ZhgA') {
  app = initializeApp({
    apiKey,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
  });
  auth = getAuth(app);

  if (import.meta.env.DEV && import.meta.env.VITE_FIREBASE_AUTH_EMULATOR) {
    connectAuthEmulator(auth, import.meta.env.VITE_FIREBASE_AUTH_EMULATOR);
  }
} else {
  console.warn(
    'Firebase not configured — set VITE_FIREBASE_API_KEY in .env.local.\n' +
    'Get it from Firebase Console → Project Settings → Web App.'
  );
}

/**
 * Call this before using any Firebase auth function.
 * Returns false (and shows a toast message) if Firebase isn't initialized.
 */
export function isFirebaseReady(): boolean {
  return auth !== null;
}

export { app, auth };
